enum OrcamentoAcaoEnum {
  OrcamentoEnviaOrcamento = 'orcamentoEnviaOrcamento',
  OrcamentoAtualizaOrcamento = 'orcamentoAtualizaOrcamento',
  OrcamentoAprovado = 'orcamentoAprovado',
  OrcamentoRecusado = 'orcamentoRecusado',
}

export default OrcamentoAcaoEnum
